export default __webpack_public_path__ + "eb71f1c23d0bc7f9b5f783aab6ad24b5.png";